import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Flex, Icon, Text } from '@homeexchange/panorama';
import i18n from '../../i18n';
import Home from '../../models/Home';
import { FLAG_CLEANING_FEES, isFeatureFlagEnabled } from '../../utils/featureFlags';

const STATES = {
    [Home.PROFESSIONAL_CLEANING_OFFERED]: {
        icon: 'Gift',
        label: 'home:page_homeview_cleaningfees_offer_desc'
    },
    [Home.PROFESSIONAL_CLEANING_CONTRIBUTION]: {
        icon: 'CoinsStack',
        label: 'home:page_homeview_cleaningfees_contribution_desc'
    },
    [Home.PROFESSIONAL_CLEANING_TO_DISCUSS]: {
        icon: 'ChatBubbles',
        label: 'home:page_homeview_cleaningfees_todiscuss_desc'
    }
};

export const formatContribution = (amount, currency, locale) => {
    try {
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
            minimumFractionDigits: Number.isInteger(Number(amount)) ? 0 : 2
        }).format(amount);
    } catch {
        return `${amount} ${currency}`;
    }
};

export const professionalCleaningState = (home) => {
    if (!home.get('has_professional_cleaner')) {
        return null;
    }
    return STATES[home.get('professional_cleaning_contribution')] ?? null;
};

export default function HomeViewProfessionalCleaning({ home }) {
    const [isCleaningFeesEnabled, setIsCleaningFeesEnabled] = useState(false);

    useEffect(() => {
        let isMounted = true;
        isFeatureFlagEnabled(FLAG_CLEANING_FEES).then((enabled) => {
            if (isMounted) {
                setIsCleaningFeesEnabled(enabled);
            }
        });
        return () => {
            isMounted = false;
        };
    }, []);

    const state = professionalCleaningState(home);
    if (!isCleaningFeesEnabled || !state) {
        return null;
    }

    const amount = formatContribution(
        home.get('professional_cleaning_amount'),
        home.get('professional_cleaning_currency'),
        i18n.language
    );

    return (
        <div className="home-professional-cleaning">
            <h2>{i18n.t('global:global_professionalcleaning')}</h2>
            <Flex align="center" gap="8">
                <Icon name={state.icon} size="large" />
                <Text variant="body-large" thin>
                    {i18n.t(state.label, { amount })}
                </Text>
            </Flex>
        </div>
    );
}

HomeViewProfessionalCleaning.propTypes = {
    home: PropTypes.instanceOf(Home).isRequired
};
